module.exports = __webpack_public_path__ + "static/media/badminton.8bd0dcdd.svg";